import { Apis } from "./index";


class ApiHome {

    static list() {
        return Apis.get('api/home/list');
    }

}

export { ApiHome };